import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService, Roles } from 'src/app/api/authentication';
import { Associate } from 'src/app/api/authentication/associate';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  notAuthorized = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.createLoginForm();
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login() {
    if (this.loginForm.valid) {
      this.loginService.login(this.loginForm.value).subscribe((user) => {
        const role = user.user.role?.name ?? '';
        if (role == Roles.ADMIN) {
          this.router.navigate(['/admin'])
        } else if (role == Roles.USER) {
          this.router.navigate(['/user'])
        } else if (role == Roles.ASSOCIATE && user.user.associate?.type == Associate.CHURCH) {
          void this.router.navigate(['/igreja'])
        } else if (role == Roles.ASSOCIATE && user.user.associate?.type == Associate.COMMERCE) {
          void this.router.navigate(['/comercio'])
        } else if (role == Roles.ASSOCIATE && user.user.associate?.type == Associate.MISSIONARY) {
          void this.router.navigate(['/missionario'])
        } else if (role == Roles.ASSOCIATE && user.user.associate?.type == Associate.SERVICEPROVIDER) {
          void this.router.navigate(['/servico'])
        } else if (role == Roles.ASSOCIATE && user.user.associate?.type == Associate.MUSICALARTIST) {
          void this.router.navigate(['/banda-cantor'])
        } else {
          // fallback: navega baseado no que vier
          this.router.navigate(['/user'])
        }
      }, error => {
        this.notAuthorized = true;
        this.loginForm.reset()
        this.toastr.error('Usuário e/ou senha incorreto(s)!')
      })
    } else {
      this.loginForm.markAllAsTouched()
      this.toastr.error('Preencha os campos inválidos !')
    }
  }
}
